import React, { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import { useRouter } from 'next/router';

// ---------------------------------------------------------

import Icon from '@components/icon';
import { useAuthenticated, useSavedListing, useUpdateSavedListing } from '@lib/user-context';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const {
  property_like_button_is_active,
  property_like_button,
  header_save,
  property_like_button_header,
  property_like_button_header_is_active
} = styles;

// ---------------------------------------------------------

export default function component(props) {
  const router = useRouter();
  const { isAuthenticated } = useAuthenticated();
  const { savedListing, isFavorited } = useSavedListing(props.id);
  const updateSavedListing = useUpdateSavedListing();

  const { id, header } = props;
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(isFavorited);
  }, [isFavorited]);

  const onClick = async () => {
    if (isAuthenticated) {
      const listing = savedListing || { listingId: id, savedListingId: 0 };
      setActive(!active);
      const ok = await updateSavedListing({ ...listing, isFavorited: !active });
      // Only an explicit false reverts the heart
      if (ok === false) setActive(active);
    } else {
      if (typeof window !== 'undefined') {
        window.location.href = '/auth/login';
      } else {
        router.push('/auth/login');
      }
    }
  };

  const debouncedClickHandler = debounce(onClick, 250);

  return (
    <>
      <button
        className={classNames(property_like_button, {
          [property_like_button_header]: header,
          [property_like_button_header_is_active]: header && !active,
          [property_like_button_is_active]: active
        })}
        onClick={debouncedClickHandler}
        title="Property like button"
      >
        <Icon type="filters" name={header && !active ? 'like-outline' : 'like'} />
        {header && <p className={header_save}>Save</p>}
      </button>
    </>
  );
}
